<template>
  <el-dialog title="实操回顾" :visible.sync="reviewDialog" :before-close="resetForm" append-to-body
    :close-on-click-modal="false">
    <el-divider />
    <div class="form-box">
      <div class="left-box">
        <div v-for="(item, index) in listData" :key="index" @click="handleTab(item, index)" class="left-list">
          <div class="video-box">
            <video :src="item.file"></video>
          </div>
          <div class="video-name">{{ item.camera_name }}</div>
        </div>
      </div>
      <div class="contont-right-video">
        <div class="plyer-box-video">
          <video ref="myVideo" class="video-js vjs-default-skin vjs-big-play-centered" crossorigin="anonymous" />
        </div>
      </div>
    </div>
    <div class="el-dialog__footer">
      <!-- <el-button type="primary" @click="submitForm">确定</el-button> -->
    </div>
  </el-dialog>
</template>
<script>
/* 引入插件 */
import videojs from "video.js"; // 引入videojs插件
import videozhCN from "video.js/dist/lang/zh-CN.json"; // 样式文件
import "../css/video.scss"; // 引入video样式
import "videojs-contrib-hls"; // video拉流播放
import "videojs-markers"; // 引入videojs-markers
import "videojs-markers/dist/videojs.markers.css"; // 引入videojs-markers样式
import "tui-image-editor/dist/tui-image-editor.css"; // 引入图片编辑器样式
import "tui-color-picker/dist/tui-color-picker.css"; // 引入颜色选择器样式
const ImageEditor = require("tui-image-editor");
const localeZh = {
  Draw: "添加绘画",
  Shape: "添加形状",
  Icon: "添加图标",
  Text: "添加文本",
};
const customTheme = {
  "common.bi.image": "",
  "common.bisize.width": "0px",
  "common.bisize.height": "0px",
  "common.backgroundImage": "none",
  "common.backgroundColor": "rgba(0, 0, 0, 0.2)",
  "loadButton.display": "none",
  "downloadButton.display": "none",
};
const videoType = {
  mp4: "video/mp4",
  webm: "video/webm",
  m3u8: "application/x-mpegURL",
};
import { cameraVideoGetList } from "@/api/courselibtimetable";
export default {
  name: "operateReview",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    reviewDialog: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  data() {
    return {
      listData: [],
      video_url: {}, // 视频地址
    };
  },
  methods: {
    loadObj(row) {
      const par = {
        camera_period_id: row.id,
      };
      cameraVideoGetList(par).then((res) => {
        if (res.code === 0) {
          let resData = res.data;
          this.listData = resData;
          if (resData && resData.length) {
            this.video_url = {
              id: resData[0].id,
              file: resData[0].file,
              camera_name: resData[0].camera_name,
              camera_id: resData[0].camera_id,
            };
          }
          if (this.video_url) {
            this.initVideo(this.video_url.file); // 初始化视频播放器
          }
        }
      });
    },
    /* 初始化视频播放器 */
    initVideo(src) {
      var that = this;
      var suffix = ""; // 自定义后缀名
      if (that.video_url.file) {
        suffix = that.video_url.file.substr(
          that.video_url.file.lastIndexOf(".") + 1
        );
      }
      var options = {
        language: "zh-CN",
        autoplay: false, // 自动播放
        preload: "auto", // 自动加载
        controls: true, // 控制条
        controlBar: true, // 设置controls为false虽然不展示，但是存在
        textTrackDisplay: false, // 不渲染字幕相关
        bigPlayButton: true,
        posterImage: true,
        errorDisplay: false, // 错误展示
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        sources: [
          { type: videoType[suffix] || "", src: src }, // 播放内容
        ],
      };
      that.$refs.myVideo.src = src;
      that.player = videojs(that.$refs.myVideo, options, () => {
        videojs.log("播放器已经准备好了!");
      });
      videojs.addLanguage("zh-CN", videozhCN);
    },
    //点击切换
    handleTab(item, index) {
      this.video_url = {
        id: item.id,
        file: item.file,
        camera_name: item.camera_name,
        camera_id: item.camera_id,
      };
      this.$nextTick(() => {
        this.initVideo(this.video_url.file); // 初始化视频播放器
      })
    },
    //取消
    resetForm() {
      this.$emit("updReview", '')
    },
  },
};
</script>

<style lang="scss" scoped>
.form-box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 30px 20px;
  display: flex;

  .left-box {
    width: 200px;
    margin: 0 20px 0 0;
    max-height: 600px;
    overflow-y: scroll;
    scrollbar-width: none;
    scrollbar-color: transparent transparent;

    .left-list {
      width: 100%;

      .video-box {
        width: 100%;
        height: 100px;
        border: solid 1px #409EFF;
        box-sizing: border-box;
        cursor: pointer;

        video {
          width: 100%;
          height: 100%;
        }
      }

      .video-name {
        width: 100%;
        text-align: center;
        padding: 10px 0 20px;
        color: #121212;
        font-size: 16px;
      }
    }
  }

  // .left-box ::-webkit-scrollbar {
  //   display: none;
  // }
  .contont-right-video {
    width: calc(100% - 220px);
    background: #fff;
    border: 1px solid #e8e8e8;
    display: flex;

    .plyer-box-video {
      position: relative;
      width: 100%;
      object-fit: fill;
      overflow: hidden;

      video {
        width: 100%;
        height: 100%;
      }

      .plyer-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;

        span {
          font-size: 16px;
          color: rgb(87, 87, 168);
          cursor: pointer;
        }
      }

      .video-list {
        cursor: pointer;

        .video-time-size {
          display: flex;
          height: 40px;
          line-height: 40px;
          flex-wrap: nowrap;
          justify-content: space-between;
          padding: 0 15px;
          font-weight: bold;
          font-size: 14px;
        }
      }
    }
  }
}

::v-deep .el-dialog {
  box-shadow: 1px 10px 9px 1px rgba(0, 82, 146, 0.1);
  border-radius: 10px;
}

::v-deep .el-dialog__header {
  padding: 20px;
}

::v-deep .el-dialog__body {
  padding: 0;

  .el-divider--horizontal {
    margin: 0 0 24px;
  }
}

.el-dialog__footer {
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;
  border-top: solid 1px #eeeeee;
}
</style>
